import charging from '../../charging';

// Deprecated
export function stopCharging(data) {
  return charging.post('/stop_charging', data);
}
